// extracted by mini-css-extract-plugin
module.exports = {"confirm__title":"confirm__title-2szoT"};